<div class='header-line' fxLayout fxLayoutAlign='space-between center'>
  <div fxLayout fxLayoutAlign='start center' fxLayoutGap='48px'>
    <ng-template #descriptionTemplate>
      <div class="description-template" [innerHTML]="formatInnerText(cardDescription | linkify)"></div>
    </ng-template>

    <div class='table-title'>{{ dashboardTitle }}</div>

    <mat-icon
      class="info-icon"
      [matTooltip]="'OPEN_DESCRIPTION' | translate"
      [matTooltipPosition]="'above'"
      (click)='openDescription(descriptionTemplate)'
    >info</mat-icon>

    <mat-form-field>
      <input matInput [matDatepicker]="picker" [formControl]="dateFilter" (click)="picker.open()">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>
</div>

<div class="progress-bar-wrapper" style="margin-top: 16px">
  <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
</div>

<ng-container *ngIf="!isLoading">
  <div class="container">
    <mat-table *ngIf="dataSource.length && columnsToDisplay.length" [dataSource]="dataSource" class="mat-elevation-z1">
      <ng-container *ngFor="let col of columnsToDisplay" [matColumnDef]="col">
        <mat-header-cell *matHeaderCellDef>

          <ng-container *ngIf="col === 'region'">
            {{ 'CRITICAL_ORDERS.REGION' | translate }}
          </ng-container>

          <ng-container *ngIf="col !== 'region'">
            {{ CONVERSION_KEY_MAP[col] | translate }}
          </ng-container>
        </mat-header-cell>

        <mat-cell *matCellDef="let element">
          {{ getColValue(element[col]) }}
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
      <mat-row *matRowDef="let row; columns: columnsToDisplay"></mat-row>
    </mat-table>
  </div>
</ng-container>
